export const convertBlobToFile = async (blobFile) => {
  return new File([blobFile], blobFile.name, {
    type: blobFile.content_type,
    lastModified: blobFile.lastModified,
  });
};
